module.exports = __webpack_public_path__ + "media/assets/images/blog/wet_window-66ad9708afa72accec6845c6b777d27a.jpg";